import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { joinCommunity } from 'modules/community/community.actions';

import { Row, BodyText, Header } from 'modules/styled';

class CommunityMembersTitle extends Component {
  static propTypes = {
    community: PropTypes.object,
  };

  render() {
    const { community } = this.props;
    const { communities, active } = community;
    const activeCommunity = communities[active];
    if (!activeCommunity) return null;
    return (
      <Row sx={{ alignItems: 'baseline' }}>
        <Header inline={1}>Community Members</Header>
        <BodyText sx={{ ml: 2 }}>{activeCommunity.memberCount} Total</BodyText>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  community: state.community,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      joinCommunity,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunityMembersTitle);
